module.exports = "<upload></upload>\n"